import { Link } from "react-router-dom";

/**
 * Marque Roof Border : le logo officiel, cliquable.
 *
 * Un seul dessin pour les deux thèmes (décision de Jeff), en deux mises en
 * page : « horizontal » (satellite + ROOFBORDER sur une ligne) pour les
 * en-têtes larges, « etroit » (BORDER sous ROOF) pour la barre latérale et le
 * bandeau mobile, où l'horizontal déborderait.
 */
const FICHIERS = {
  horizontal: "logo-roofborder-horizontal.png",
  etroit: "logo-roofborder-etroit.png",
};

const HAUTEURS = {
  sm: "h-6",
  md: "h-8",
  lg: "h-10",
  xl: "h-[70px]",
};

export default function Marque({ taille = "md", variante = "horizontal", className = "", vers = "/" }) {
  const image = (
    <img
      src={`${process.env.PUBLIC_URL}/${FICHIERS[variante] || FICHIERS.horizontal}`}
      alt="Roof Border"
      className={`${HAUTEURS[taille] || HAUTEURS.md} w-auto shrink-0 ${className}`}
    />
  );
  // vers = "" pour un usage déjà enveloppé dans un lien (pas de <a> imbriqué).
  if (!vers) return image;
  return (
    <Link to={vers} aria-label="Roof Border" className="inline-flex items-center shrink-0">
      {image}
    </Link>
  );
}
